import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import { Easing } from '@tweenjs/tween.js';
import Point from '../../../Utility/Point';
import ElementComponent from '../../../Component/UI/Element';
import { tEasing } from '../../../Utility/Types';

interface IScalePulseLoopMeta {
    duration?: number;
    scale: Point;
    repeat?: number;
    yoyo?: boolean;
    easing?: tEasing;
}
export class ScalePulseLoop extends AnimationClip<IScalePulseLoopMeta> {
    public *execute(
        gameObject: GameObject,
        meta: IScalePulseLoopMeta
    ): IterableIterator<number> {
        const {
            scale,
            duration = 250,
            repeat = Infinity,
            yoyo = true,
            easing = Easing.Linear.None,
        } = meta;
        const component =
            gameObject.getComponent(ElementComponent) ??
            gameObject.getComponent(TransformComponent);

        const tween = this.getTween(component.scale).to(
            { x: scale.x, y: scale.y },
            duration
        );
        let animating: boolean = true;

        tween
            .yoyo(yoyo)
            .repeat(repeat)
            .easing(easing);

        yield* this.startTween(tween);
    }
}
